import { Box, Flex, Heading, HStack, IconButton } from '@chakra-ui/react'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate } from 'react-router'
import { devicesApi } from '~/apis/devicesApi'
import { useUserState } from '~/atoms/UserState'
import { UnsavedChangesDialog } from '~/components/shared/UnsavedChangesDialog'
import { toaster } from '~/components/ui/toaster'
import { ApplicationRoutes } from '~/types/RoutingTypes'

import { DeviceNewPage as DeviceNewPageLib } from '@mangovoice/devices-ui'

export const DeviceNewPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pbxId, userRoles } = useUserState({ canAutoRefresh: false })
  const safePbxId = pbxId ?? 0
  const isInternalUser = Boolean(userRoles?.is_staff || userRoles?.is_superuser)

  if (!safePbxId) return null
  // Legacy parity: only Mango staff / superusers can create devices.
  if (!isInternalUser)
    return <Navigate to={ApplicationRoutes.DEVICES} replace />

  return (
    <Flex direction="column" h="full">
      <HStack px={6} py={3} gap={2} flexShrink={0}>
        <IconButton
          variant="ghost"
          size="sm"
          onClick={() => navigate(ApplicationRoutes.DEVICES)}
          aria-label={t('common.back', 'Back')}
        >
          <ArrowLeft />
        </IconButton>
        <Heading size="md">{t('devices.new.heading', 'New Device')}</Heading>
      </HStack>
      <Box flex={1} overflow="auto">
        <DeviceNewPageLib
          api={devicesApi}
          pbxId={safePbxId}
          navigate={navigate}
          toast={toaster}
          listRoute={ApplicationRoutes.DEVICES}
          UnsavedChangesDialog={UnsavedChangesDialog}
          showInternalFields={isInternalUser}
          t={t}
        />
      </Box>
    </Flex>
  )
}
